 import React, { useState } from "react";
 import "../App.css";
 import { useNavigate } from "react-router-dom";

 function Register({ onSwitchToLogin }) {
   // State variables for user input
   const [username, setUsername] = useState("");
   const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [message, setMessage] = useState("");
   const navigate = useNavigate();

   // Handle registration form submission
   const handleRegister = async (e) => {
     e.preventDefault();

     const userData = { username, email, password };

     try {
       const response = await fetch("https://internproject-backend-52635102117.us-west1.run.app/api/auth/register", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify(userData),
       });

      if (response.ok) {
          setMessage("Registration successful! Redirecting to login...");
          navigate("/login");
      } else {
          const errorText = await response.text();
          setMessage(errorText || "Registration failed.");
      }
     } catch (error) {
       setMessage("Error connecting to backend.");
     }
   };

   return (
     <div className="form-container">
       <div className="form-box">
         <h2>User Registration</h2>
         <form onSubmit={handleRegister}>
           <input
             type="text"
             placeholder="Username"
             value={username}
             onChange={(e) => setUsername(e.target.value)}
           />
           <input
             type="email"
             placeholder="Email"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
           />
           <input
             type="password"
             placeholder="Password"
             value={password}
             onChange={(e) => setPassword(e.target.value)}
           />
           <button type="submit">Register</button>
         </form>

         <p>{message}</p>

         <p style={{ marginTop: "20px" }}>
           Already have an account?{" "}
           <button
             onClick={() => navigate("/login")}
             style={{ background: "none", border: "none", padding: 0, color: "#3a42ff", textDecoration: "underline", cursor: "pointer" }}
           >
             Login
           </button>
         </p>
       </div>
     </div>
   );
 }

 export default Register;
